import { useLanguage } from '../contexts/LanguageContext';

/* Iconos de los datos de contacto */
const ICONS = {
  phone: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
    </svg>
  ),
  mail: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
      <polyline points="22,6 12,13 2,6" />
    </svg>
  ),
  pin: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
      <circle cx="12" cy="10" r="3" />
    </svg>
  ),
  chat: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
    </svg>
  ),
  clock: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" />
      <polyline points="12 6 12 12 16 14" />
    </svg>
  ),
  whatsapp: (
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M17.47 14.38c-.3-.15-1.75-.86-2.02-.96-.27-.1-.47-.15-.67.15-.2.3-.77.96-.94 1.16-.17.2-.35.22-.64.07-.3-.15-1.25-.46-2.38-1.47-.88-.79-1.48-1.75-1.65-2.05-.17-.3-.02-.46.13-.61.14-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.08-.15-.67-1.6-.92-2.2-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.79.37-.27.3-1.04 1.01-1.04 2.47s1.06 2.87 1.21 3.07c.15.2 2.1 3.2 5.08 4.49.71.3 1.26.49 1.69.63.71.22 1.36.19 1.87.12.57-.09 1.75-.72 2-1.41.25-.69.25-1.28.17-1.41-.07-.13-.27-.2-.57-.35z" />
      <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2 22l5.25-1.38a9.87 9.87 0 0 0 4.79 1.22h.01c5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01A9.82 9.82 0 0 0 12.04 2zm0 18.13a8.2 8.2 0 0 1-4.18-1.15l-.3-.18-3.11.82.83-3.04-.2-.31a8.19 8.19 0 0 1-1.26-4.36c0-4.54 3.7-8.24 8.24-8.24 2.2 0 4.27.86 5.83 2.42a8.18 8.18 0 0 1 2.41 5.83c0 4.54-3.7 8.24-8.24 8.24z" />
    </svg>
  ),
};

/* Una fila de datos dentro de un panel de cristal */
function ContactoRow({ item }) {
  const content = (
    <>
      <span className="contacto-row-icon">{ICONS[item.icon]}</span>
      <span className="contacto-row-body">
        <span className="contacto-row-label">{item.label}</span>
        <span className="contacto-row-value">{item.value}</span>
      </span>
    </>
  );

  const className = `contacto-row ${item.modifier || ''}`;

  if (item.openChatbot) {
    return (
      <button
        type="button"
        className={`${className} contacto-row--action`}
        onClick={() => window.dispatchEvent(new CustomEvent('openChatbot'))}
      >
        {content}
      </button>
    );
  }

  if (item.href) {
    const external = item.href.startsWith('http');
    return (
      <a
        href={item.href}
        className={`${className} contacto-row--action`}
        {...(external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
      >
        {content}
      </a>
    );
  }

  return <div className={className}>{content}</div>;
}

function Contacto() {
  const { t } = useLanguage();

  /* Columna principal: las vías directas para cerrar una visita */
  const principales = [
    {
      id: 'tel1',
      icon: 'phone',
      label: t('contact.phone1'),
      value: '+34 654 86 66 34',
      href: 'tel:+34654866634',
    },
    {
      id: 'tel2',
      icon: 'phone',
      label: t('contact.phone2'),
      value: '+34 661 69 05 97',
      href: 'tel:+34661690597',
    },
    {
      id: 'whatsapp',
      icon: 'whatsapp',
      label: t('contact.whatsappLabel'),
      value: t('contact.whatsappValue'),
      href: 'https://wa.me/34654866634',
      modifier: 'contacto-row--whatsapp',
    },
    {
      id: 'mail',
      icon: 'mail',
      label: t('contact.email'),
      value: 'admin@brundingestion.com',
      href: 'mailto:admin@brundingestion.com',
    },
  ];

  /* Columna secundaria: dónde estamos, cuándo y el chat */
  const secundarios = [
    {
      id: 'address',
      icon: 'pin',
      label: t('contact.addressLabel'),
      value: t('contact.addressValue'),
      href: 'https://maps.app.goo.gl/CTDSg8BAdHbu64ta9',
    },
    {
      id: 'schedule',
      icon: 'clock',
      label: t('contact.scheduleLabel'),
      value: t('contact.scheduleValue'),
    },
    {
      id: 'chat',
      icon: 'chat',
      label: t('contact.chatLabel'),
      value: t('contact.chatValue'),
      openChatbot: true,
    },
  ];

  return (
    <section className="section section--contacto">
      <div className="section-contacto-bg" />
      <div className="section-contacto-content">
        <h1 className="section-title section-title--light contacto-title">{t('contact.title')}</h1>
        <p className="contacto-intro">
          {t('contact.intro')}
        </p>

        {/* Dos columnas: a la izquierda las vías de contacto directo,
            a la derecha la información de apoyo. */}
        <div className="contacto-layout">
          <div className="contacto-panel contacto-panel--main">
            <h2 className="contacto-panel-title">{t('contact.directHeading')}</h2>
            <div className="contacto-rows">
              {principales.map((item) => (
                <ContactoRow key={item.id} item={item} />
              ))}
            </div>
          </div>

          <div className="contacto-panel contacto-panel--aside">
            <h2 className="contacto-panel-title">{t('contact.infoHeading')}</h2>
            <div className="contacto-rows">
              {secundarios.map((item) => (
                <ContactoRow key={item.id} item={item} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contacto;
